module.exports = __webpack_public_path__ + "img/404.9e9b228d.jpg";